import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import division6Data from "../config/app-context/division-6.json";
import division9Data from "../config/app-context/division-9.json";
import FeatureCard from "../Components/FeatureCard";
import VideoBackground from "../Components/VideoBackground";
import svgHolistic from "../assets/vectors/rotating_words/txt_holistic.svg";
import svgNutritionist from "../assets/vectors/rotating_words/txt_nutritionist.svg";
import svgDermatologist from "../assets/vectors/rotating_words/txt_dermatologist.svg";
import svgFitness from "../assets/vectors/rotating_words/txt_fitness.svg";
import svgTherapist from "../assets/vectors/rotating_words/txt_therapist.svg";
import howFeatures from "../config/app-context/division-5.json";
import BlogsSection from "../Components/BlogsSection";
import readButtonSvg from "../assets/vectors/read-now-btn-default.svg"; // You'll need to create/import these SVGs
import readButtonHoverSvg from "../assets/vectors/read-now-btn-hover.svg";
import circleDecorationSvg from "../assets/vectors/circle-decoration.svg";


const getAsset = (assetName) => {
  try {
    return require(`../assets/${assetName}`);
  } catch (err) {
    console.error(`Failed to load image: ${assetName}`, err);
    return null;
  }
};

const MainPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  const [appData, setAppData] = useState(null); // State to hold all fetched config and populated media
  const [assetUrls, setAssetUrls] = useState({}); // Removed - URLs should be within appData
  const [isLoading, setIsLoading] = useState(true);
  // Refs for scrolling elements
  const whyCardsRef = useRef(null);

  const [activeFeatureSlide, setActiveFeatureSlide] = useState(0);
  const timerRef = useRef(null);
  const { featuresSection } = howFeatures;
  const { features, mainHeading, textColor, transitionSpeed } = featuresSection;

  const concernSectionRef = useRef(null);
  const [cardsFloated, setCardsFloated] = useState(false);

  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [blogs, setBlogs] = useState([]);
  const [loadingBlogs, setLoadingBlogs] = useState(true);
  const apiBaseUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost:1337'       // <--- URL for local development
    : 'https://strapi.genomii.ai'; // <--- URL for production

  

    const getMappedAssetUrl = (assetIdentifier) => {
      if (!assetIdentifier || typeof assetIdentifier !== 'string') {
        // console.warn(`Invalid asset identifier received: ${assetIdentifier}`);
        return null;
      }

      // Prioritize direct match (if identifier is already just the filename)
      if (assetUrls[assetIdentifier]) {
          return assetUrls[assetIdentifier];
      }

      // If no direct match, assume it's a path and extract filename
      const fileName = assetIdentifier.includes('/') ? assetIdentifier.split('/').pop() : assetIdentifier;
      const url = assetUrls[fileName];

      // if (!url) {
      //     console.warn(`Asset URL not found in map for identifier: ${assetIdentifier} (filename: ${fileName})`);
      // }
      return url || null; // Return URL or null if not found
  };

  const testimonialsData = appData?.division8;
  const testimonialsArray = testimonialsData?.testimonials || [];

  const defaultButtonIdentifier = appData?.division9?.buttonImages?.default;
const hoverButtonIdentifier = appData?.division9?.buttonImages?.hover;

// 2. Look up the URLs using the helper function (it handles path splitting)
const defaultButtonUrl = getMappedAssetUrl(defaultButtonIdentifier);
const hoverButtonUrl = getMappedAssetUrl(hoverButtonIdentifier);

// 3. Get alt text
const buttonAltText = appData?.division9?.buttonText
  const handleNextFeature = () => {
    // Clear the existing timer
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    // Update to next slide
    setActiveFeatureSlide((prev) => (prev + 1) % features.length);

    // Start a fresh timer
    startFeatureTimer();
  };

  // transitionSpeed parameter is in config/how_does_it_work.json
  const startFeatureTimer = () => {
    timerRef.current = setInterval(() => {
      setActiveFeatureSlide((prev) => (prev + 1) % features.length);
    }, transitionSpeed || 1500);
  };

  const emailInputRef = useRef(null);

  // Add a scroll function to the component
  const scrollToEmailInput = () => {
    emailInputRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [signupSuccess, setSignupSuccess] = useState(false);
  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  // Add this function to handle the form submission
  const handleEmailSignup = async (e) => {
    e.preventDefault();

    // Reset states
    setEmailError("");
    setSignupSuccess(false);

    // Validate email
    if (!email.trim()) {
      setEmailError("Please enter your email address");
      return;
    }

    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    try {
      setIsSubmitting(true);

      // Get the API URL from environment variable
      const API_URL = process.env.REACT_APP_API_URL;

      // Send the request to the backend
      const response = await fetch(`${API_URL}/beta-signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok && response.status !== 200) {
        throw new Error(data.error || "Failed to sign up");
      }

      // Check for the case where user is already registered
      if (data.alreadyRegistered) {
        setSignupSuccess(true);
        // Optionally show a different message for existing users
        // But still consider it a success
      } else {
        setSignupSuccess(true);
      }

      // Clear the email field on success
      setEmail("");
    } catch (error) {
      console.error("Signup error:", error);
      setEmailError(error.message || "An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const [wordIndex, setWordIndex] = useState(0);
  const rotatingSvgs = [
    svgHolistic,
    svgNutritionist,
    svgDermatologist,
    svgFitness,
    svgTherapist,
  ];
  const rotatingAlts = [
    "holistic wellness",
    "nutritionist",
    "dermatologist",
    "fitness coach",
    "therapist",
  ];
  const [currentSvg, setCurrentSvg] = useState(rotatingSvgs[0]);
  const [prevSvg, setPrevSvg] = useState(null);
  const [animationState, setAnimationState] = useState("initial");
  const testimonialIntervalRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setAppData(null);
      setAssetUrls({}); // Reset asset URLs at the start
      try {
        // Construct the URL with specific fields for media
        const populateFields = [
          'populate[images][fields][0]=name', 'populate[images][fields][1]=url',
          'populate[videos][fields][0]=name', 'populate[videos][fields][1]=url',
          'populate[vectors][fields][0]=name', 'populate[vectors][fields][1]=url'
        ].join('&');
        const configUrl = `${apiBaseUrl}/api/main-page-config?${populateFields}`;

        // console.log("Fetching URL:", configUrl); // Optional: Log URL for debugging

        const response = await fetch(configUrl);

        if (!response.ok) {
          let errorBody = 'Error details unknown.';
          try { errorBody = await response.text(); } catch (e) { /* ignore */ }
          console.error(`API Error Response (${response.status}):`, errorBody);
          throw new Error(`Failed to fetch main page config: ${response.status} ${response.statusText}.`);
        }

        const result = await response.json();
        // console.log("API Response Received:", result); // Optional: Log raw result

        // Check if result.data exists (it contains the fields directly)
        if (result.data) {
          const pageData = result.data; // Use result.data instead of result.data.attributes

          setAppData(pageData); // Set the main data object

          // Create the asset URL map from ALL media arrays within pageData
          const urlsMap = {};
          const mediaTypesToProcess = ['images', 'videos', 'vectors'];

          mediaTypesToProcess.forEach(mediaType => {
            const mediaList = pageData[mediaType]; // Access arrays directly from pageData

            if (mediaList && Array.isArray(mediaList)) {
              mediaList.forEach(mediaItem => {
                // When populating specific fields, Strapi often still nests them under attributes
                // within the related item. Check for attributes first.
                let name = mediaItem?.attributes?.name;
                let url = mediaItem?.attributes?.url; // <-- URL from Strapi

                // Fallback check: Sometimes specific fields might be direct properties (less common with populate[fields])
                if (!name && mediaItem?.name) name = mediaItem.name;
                if (!url && mediaItem?.url) url = mediaItem.url;


                if (name && url) {
                  // --- *** THIS IS THE CORRECTION *** ---
                  // Check if the URL from Strapi is already absolute (starts with http/https)
                  const isAbsoluteUrl = url.startsWith('http://') || url.startsWith('https://');

                  // If it IS absolute, use it directly.
                  // If it's relative (like '/uploads/...'), THEN prepend apiBaseUrl.
                  const finalUrl = isAbsoluteUrl ? url : `${apiBaseUrl}${url}`;
                  // --- *** END CORRECTION *** ---

                  // Ensure name collision doesn't overwrite (though unlikely with unique uploads)
                  if (urlsMap[name]) {
                    console.warn(`Duplicate asset name found in map: ${name}. Overwriting URL.`);
                  }
                  // Assign the correctly determined URL
                  urlsMap[name] = finalUrl;

                } else {
                  // Log if an item in the media array doesn't have the expected structure
                  console.warn(`Media item in '${mediaType}' missing expected name/url attributes:`, mediaItem);
                }
              });
            }
          });
          setAssetUrls(urlsMap); // Set the corrected map to state
          console.log("DEBUG: Populated Asset URLs map:", urlsMap); // Verify the URLs here

          // console.log("Processed App Data:", pageData); // Optional debug log

        } else {
          // If result.data itself is missing
          console.error("API response missing 'data' field:", result);
          throw new Error("Fetched data response was missing 'data' field.");
        }

      } catch (error) {
        // Log the actual error caught during fetch or processing
        console.error("Error in fetchData:", error);
        setAppData(null); // Reset data on error
        setAssetUrls({}); // Reset URLs on error
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  // Dependency array - apiBaseUrl might change between dev/prod, so keep it.
  }, [apiBaseUrl]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/api/blogs?populate=*&pagination[pageSize]=9&sort=publishedAt:desc`
        );
        
        if (!response.ok) {
          throw new Error(`Failed to fetch blogs: ${response.status}`);
        }
        
        const data = await response.json();
        
        // Format blogs for the BlogsSection component
        const formattedBlogs = data.data.map(item => ({
          id: item.id,
          documentId: item.documentId,
          title: item.title,
          author: item.author_name || "Genomii",
          publishedAt: item.publishedAt || item.createdAt,
          imageUrl: item.cover_image?.url || '/placeholder-image.jpg',
          url: `/blog/${item.documentId}`
        }));
        
        setBlogs(formattedBlogs);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoadingBlogs(false);
      }
    };
    
    fetchBlogs();
  }, []);

  useEffect(() => {
    // Function to check if viewport is mobile size
    const checkIfMobile = () => {
      const mobile = window.innerWidth < 640;
      setIsMobile(mobile);
    };

    // Check on initial load
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkIfMobile);

    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  useEffect(() => {
    let animationInProgress = false;

    const rotateSvg = () => {
      if (animationInProgress) return;

      animationInProgress = true;
      setAnimationState("exiting");

      // Save current SVG as previous SVG
      setPrevSvg(currentSvg);

      // After exit animation completes, update to new SVG
      setTimeout(() => {
        // Calculate next index and update state
        const nextIndex = (wordIndex + 1) % rotatingSvgs.length;
        setWordIndex(nextIndex);
        setCurrentSvg(rotatingSvgs[nextIndex]);
        setAnimationState("entering");

        // After enter animation completes, reset state
        setTimeout(() => {
          setAnimationState("initial");
          animationInProgress = false;
        }, 700); // Increased for smoother animation
      }, 500); // Increased for smoother transition
    };

    // Set up the interval with longer duration
    const interval = setInterval(rotateSvg, 4000);

    // Clean up function
    return () => {
      clearInterval(interval);
    };
  }, [wordIndex]); // Simplified dependency array

  // Effect for automatic transitions in the How It Works section
  useEffect(() => {
    startFeatureTimer();

    // Cleanup on unmount
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [features.length]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !cardsFloated) {
          setCardsFloated(true);
        }
      },
      { threshold: 0.3 } // When 30% of the section is visible
    );

    if (concernSectionRef.current) {
      observer.observe(concernSectionRef.current);
    }

    return () => {
      if (concernSectionRef.current) {
        observer.unobserve(concernSectionRef.current);
      }
    };
  }, [cardsFloated]);

  // Effect for improved horizontal scrolling animation in the Why Cards section
  useEffect(() => {
    if (whyCardsRef.current) {
      const scrollContainer = whyCardsRef.current;
      const scrollWidth = scrollContainer.scrollWidth;
      const clientWidth = scrollContainer.clientWidth;

      // If there's not enough content to scroll, don't animate
      if (scrollWidth <= clientWidth) return;

      let animationFrame;
      let scrollLeft = 0;
      let direction = 1; // 1 for right, -1 for left
      const scrollSpeed = 0.3; // Adjust scroll speed as needed

      const scroll = () => {
        // Calculate the maximum scroll position that doesn't leave white space
        const maxScroll = scrollWidth - clientWidth;

        // Update scroll position based on direction and speed
        scrollLeft += scrollSpeed * direction;

        // Handle direction changes to avoid white space
        if (scrollLeft >= maxScroll) {
          scrollLeft = maxScroll; // Prevent overshooting
          direction = -1;
        } else if (scrollLeft <= 0) {
          scrollLeft = 0; // Prevent overshooting
          direction = 1;
        }

        // Apply the scroll position
        scrollContainer.scrollLeft = scrollLeft;

        // Continue animation
        animationFrame = requestAnimationFrame(scroll);
      };

      // Start the animation
      animationFrame = requestAnimationFrame(scroll);

      // Clean up on unmount
      return () => cancelAnimationFrame(animationFrame);
    }
  }, [isLoading]);
  // Effect for automatic transitions in the Testimonials section
  useEffect(() => {
    // Use the testimonialsArray derived from appData after loading is complete
    if (!isLoading && testimonialsArray && testimonialsArray.length > 0) {

      // Clear any previous interval when the effect re-runs (e.g., if data changes)
      if (testimonialIntervalRef.current) {
          clearInterval(testimonialIntervalRef.current);
      }

      // Set up the new interval
      const intervalId = setInterval(() => {
        setActiveTestimonial((prev) =>
          // Use the current length of the fetched array
          (prev + 1) % testimonialsArray.length
        );
      }, 5000); // Change testimonial every 5 seconds

      // Store the new interval ID in the ref
      testimonialIntervalRef.current = intervalId;

      // Cleanup function for when the component unmounts or dependencies change
      return () => {
        if (testimonialIntervalRef.current) {
            clearInterval(testimonialIntervalRef.current);
            testimonialIntervalRef.current = null; // Clear ref on cleanup
        }
      };
    } else {
        // If loading or no testimonials, ensure any existing interval is cleared
         if (testimonialIntervalRef.current) {
             clearInterval(testimonialIntervalRef.current);
             testimonialIntervalRef.current = null;
         }
    }
    // Depend on isLoading and the testimonialsArray itself
    // This ensures the effect runs when loading finishes AND if the array content changes
  }, [isLoading, testimonialsArray]);

  return (
    <div className="font-sans text-gray-800">
      <Header onSignUpClick={scrollToEmailInput} />

      {/* Division 1: Aging Process */}
      <section className="relative pt-16 pb-12 px-0 sm:px-4 md:px-6 lg:px-8 overflow-hidden">
        <div className="w-full">
          {/* Responsive margins that adjust based on screen size */}
          <div className="px-4 sm:px-6 md:ml-[8%] lg:ml-[12%] w-full sm:w-[90%] lg:w-[80%]">
            {/* Gradient heading text */}
            {isMobile ? (
              <img
                src={getMappedAssetUrl('aging_txt_mobile.svg')}
                alt={appData?.division1?.headingAlt} 
                className="w-full mb-16 md:mb-24 lg:mb-32"
              />
            ) : (
              <img
                src={getMappedAssetUrl('aging_txt_pc.svg')}
                alt={appData?.division1?.headingAlt}
                className="w-full mb-10"
              />
            )}

            {/* Button with responsive positioning - single line on mobile */}
            <div className="flex -ml-[2%] sm:ml-[12%] md:-ml-[3%] mt-6 md:mt-8 lg:mt-12 justify-center">
              <button
                className="font-dm-sans bg-gradient-to-r from-[#355F5C] via-[#6DC5BD] to-[#355F5C] text-white rounded-full hover:shadow-lg transition-all mb-8 md:mb-12 lg:mb-16 py-2 sm:py-3 md:py-4 px-4 sm:px-6 md:px-8 text-center font-normal w-auto"
                style={{
                  fontSize: "clamp(1rem, 4.5vw, 2rem)",
                  lineHeight: "1.2",
                  whiteSpace: "nowrap",
                }}
                onClick={scrollToEmailInput} // Add this onClick handler
              >
                Start listening now
              </button>
            </div>
          </div>
        </div>

        {/* Full-width image - no horizontal constraints on mobile */}
        <div className="mt-8 mx-0">
          <img
            src={getMappedAssetUrl('aging-process.png')}
            alt={appData?.division1?.mainImageAlt}
            className="w-full h-auto object-cover sm:rounded-lg"
          />
        </div>
      </section>

      {/* Division 2: Video Background - REPLACED WITH COMPONENT */}
      {isLoading ? (
      // Optional: Show a placeholder or loading spinner with the correct aspect ratio
      // to prevent layout shifts. You can style this div further.
      <div
        className="relative w-full bg-gray-300 animate-pulse" // Example placeholder style
        style={{ aspectRatio: isMobile ? '9/16' : '16/9' }}
        aria-busy="true"
        aria-label="Loading video section"
      >
        {/* You could add a centered spinner icon here */}
      </div>
    ) : 
      <VideoBackground
        mobileVideo={getMappedAssetUrl('vdo_geniipage_mobile.mp4')}
        desktopVideo={getMappedAssetUrl('vdo_geniipage_pc.mp4')}
        isMobile={isMobile}
      >
        {/* Keep all the content from inside your original video section */}
        {/* Top heading */}
        <div className="flex-grow flex items-center justify-center mt-6 sm:mt-8 md:mt-10">
          <div className="mx-auto text-left sm:text-left w-[90%] sm:w-[80%] lg:ml-[15%]">
            <h2 className="text-white text-[1.75rem] sm:text-4xl md:text-4xl lg:text-5xl xl:text-7xl font-bold leading-tight">
            {isMobile
                ? (appData?.division2?.mainHeading?.mobile || '')
                : (appData?.division2?.mainHeading?.desktop || '')}
            </h2>
          </div>
        </div>

        {/* Bottom content - with more spacing from bottom to avoid letterboxing */}
        <div className="mb-6 sm:mb-8 md:mb-12 lg:mb-16">
          {/* "HEY, IT'S GENNI" centered text with flex alignment */}
          <div className="text-center mb-1">
            <div
              className={`flex items-center justify-center ${
                isMobile
                  ? "text-xl"
                  : "text-base sm:text-base md:text-xl lg:text-2xl xl:text-3xl"
              }`}
            >
              <span style={{ color: "#4E837B" }}>
                {appData?.division2?.geniiIntro}
              </span>
              <img
                src={getMappedAssetUrl('GENNI.svg')}
                alt="GENNI"
                className={`${
                  isMobile ? "h-12" : "h-7 sm:h-11 md:h-12 lg:h-14 xl:h-16"
                } translate-y-0.5`}
              />
            </div>
          </div>

          {/* Animated word rotation with flex alignment */}
          <div className="text-center mb-3 sm:mb-4 md:mb-6 lg:mb-8">
            <div className="w-[95%] mx-auto flex flex-nowrap items-center justify-center">
              <div
                className={`flex flex-nowrap items-center justify-between font-bold ${
                  isMobile
                    ? "w-full text-2xl"
                    : "text-xl sm:text-xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl"
                }`}
              >
                <span
                  className="inline-block bg-gradient-to-r from-[#57A49D] to-[#A475C2] bg-clip-text text-transparent"
                  style={{
                    background:
                      "linear-gradient(89.85deg, #57A49D 0.12%, #A475C2 97.5%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    paddingBottom: "0.6rem",
                  }}
                >
                  {appData?.division2?.rotatingPhrase?.prefix}
                </span>
                <div
                  className={`relative ${
                    isMobile ? "flex-grow mx-1" : "mx-2 md:mx-3 lg:mx-4 xl:mx-5"
                  }`}
                >
                  <div
                    className={`font-bold relative ${
                      isMobile
                        ? "h-14 w-full"
                        : "h-10 sm:h-10 md:h-14 lg:h-16 xl:h-20 min-w-[12rem] sm:min-w-[14rem] md:min-w-[18rem] lg:min-w-[22rem] xl:min-w-[28rem]"
                    } flex items-center justify-center`}
                  >
                    {/* Exiting SVG */}
                    {animationState === "exiting" && prevSvg && (
                      <div className="absolute left-0 right-0 flex justify-center animate-word-exit">
                        <img
                          src={prevSvg}
                          alt={
                            rotatingAlts[
                              (wordIndex - 1 + rotatingSvgs.length) %
                                rotatingSvgs.length
                            ]
                          }
                          className="h-full max-h-[90%] object-contain"
                        />
                      </div>
                    )}

                    {/* Entering SVG */}
                    {animationState === "entering" && (
                      <div className="absolute left-0 right-0 flex justify-center animate-word-enter">
                        <img
                          src={currentSvg}
                          alt={rotatingAlts[wordIndex]}
                          className="h-full max-h-[90%] object-contain"
                        />
                      </div>
                    )}

                    {/* Static SVG */}
                    {animationState === "initial" && (
                      <div className="absolute left-0 right-0 flex justify-center">
                        <img
                          src={currentSvg}
                          alt={rotatingAlts[wordIndex]}
                          className="h-full max-h-[90%] object-contain"
                        />
                      </div>
                    )}
                  </div>
                </div>
                <span
                  className="inline-block bg-gradient-to-r from-[#57A49D] to-[#A475C2] bg-clip-text text-transparent"
                  style={{
                    background:
                      "linear-gradient(89.85deg, #57A49D 0.12%, #A475C2 97.5%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    paddingBottom: "0.6rem",
                  }}
                >
                  {appData?.division2?.rotatingPhrase?.suffix}
                </span>
              </div>
            </div>
          </div>

          {/* Email signup bar */}
          <div id="email-signup" className="mx-auto w-[90%] sm:w-[95%] md:w-[70%] lg:w-[60%] xl:w-[50%]">
            <form onSubmit={handleEmailSignup} className="flex flex-col">
              <div
                className={`flex flex-row ${
                  isMobile ? "rounded-2xl" : "rounded-full"
                } overflow-hidden bg-white shadow-lg`}
              >
                <input
                  ref={emailInputRef}
                  type="email"
                  placeholder={appData?.division2?.emailSignupPlaceholder}
                  className="flex-grow px-3 sm:px-3 md:px-4 py-2 sm:py-2 md:py-3 lg:py-3.5 focus:outline-none w-full sm:w-auto text-sm sm:text-sm md:text-base lg:text-lg"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                />
                <button
                  type="submit"
                  className={`bg-gradient-to-r from-[#355F5C] to-[#6DC5BD] text-white px-2 sm:px-3 md:px-6 lg:px-8 py-2 sm:py-2 md:py-3 lg:py-3.5 font-medium whitespace-nowrap hover:from-[#2a4c4a] hover:to-[#5bb1aa] transition-colors text-sm sm:text-sm md:text-base lg:text-lg ${
                    isSubmitting ? "opacity-70 cursor-wait" : ""
                  }`}
                  disabled={isSubmitting}
                >
                  {isSubmitting
                    ? (appData?.division2?.signingUpText || 'Signing Up...')
                    : (appData?.division2?.signupButtonText || 'Sign Up')}
                </button>
              </div>

              {/* Error or success message */}
              {emailError && (
                <div className="mt-2 text-red-500 text-sm md:text-base px-2">
                  {emailError}
                </div>
              )}

              {signupSuccess && (
                <div className="mt-2 text-green-500 text-sm md:text-base px-2">
                  {appData?.division2?.successMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </VideoBackground>}

      {/* Division 3: Slogan */}
      <section className="py-12 sm:py-16 md:py-20 bg-gray-50 flex items-center min-h-[35vh]">
        <div className="container mx-auto px-4 sm:px-6 relative">
          <div className="flex flex-col items-start">
            <h2
              className="font-dm-sans sm:text-3xl md:text-4xl lg:text-5xl lg:leading-tight font-bold mb-4 sm:mb-6 text-transparent mx-5 mt-10 sm:ml-[15%] sm:max-w-[90%] md:max-w-[70%] lg:max-w-[70%]"
              style={{
                background:
                  "linear-gradient(89.85deg, #57A49D 0.12%, #A475C2 97.5%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              {appData?.division3?.slogan}
            </h2>

            {/* Positioned signature */}
            <div className="self-end mr-[15%] mb-6">
              <p
                className="font-dm-sans text-sm sm:text-lg lg:text-2xl"
                style={{ color: "#4E837B" }}
              >
                {appData?.division3?.signature || '– Powered by Genomii AI'}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Division 4: Why Choose Genomii - with SEO-friendly text */}
      {isLoading ? (
        // Placeholder with matching vertical padding and background
        // Adjust height/content as needed for your desired loading appearance
        <div
          className="py-16 bg-white animate-pulse"
          aria-busy="true"
          aria-label="Loading why Genomii section"
        >
           <div className="container mx-auto px-6">
              {/* Simple height placeholder, or add skeleton loaders */}
              <div className="h-6 w-1/3 bg-gray-300 rounded mb-4 md:ml-[15%]"></div>
              <div className="h-10 w-1/2 bg-gray-300 rounded mb-24 md:ml-[15%]"></div>
              <div className="flex space-x-8 overflow-hidden pb-12">
                 <div className="bg-gray-300 rounded-lg h-64 w-1/2 min-w-[480px]"></div>
                 <div className="bg-gray-300 rounded-lg h-64 w-1/2 min-w-[480px]"></div>
              </div>
           </div>
        </div>
      ) : <section className="py-16 bg-white">
  <div className="container mx-auto px-6">
    {/* Two-part heading with different styling, left-aligned with margin */}
    <div className="md:mb-24 md:ml-[15%] md:max-w-[45%]">
      <h2
        className="text-2xl font-bold mb-3"
        style={{ color: "#143E39" }}
      >
        {appData?.division4?.preHeading || ''}
      </h2>
      <div
        className="text-3xl md:text-4xl lg:text-6xl font-bold text-transparent"
        style={{
          background:
            "linear-gradient(89.85deg, #57A49D 0.12%, #A475C2 97.5%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
          WebkitBackgroundClip: "text",
          color: "transparent",
          backgroundClip: "text",
          paddingBottom: "0.6rem",
        }}
      >
        {appData?.division4?.mainHeading || ''}
      </div>
    </div>

    <div className="h-12 w-full"></div>

    {/* SVG Card Scrolling Section with SEO-friendly text loaded from JSON */}
    <div className="w-full mt-4 relative">
      <div
        ref={whyCardsRef}
        className="flex space-x-8 overflow-x-auto hide-scrollbar pb-12"
      >
        {/* Map through feature cards from division4Data */}
        {(appData?.division4?.featureCards || []).map((card, index) => {
          // Array of card SVG imports
          const svgFileName = `bdg_card${index + 1}.svg`;
          const svgUrl = getMappedAssetUrl(svgFileName);

          return (
            <FeatureCard
              key={card.id}
              svgSrc={svgUrl}
              heading={card.heading}
              bodyText={card.bodyText}
              className="w-1/2 min-w-[480px] max-w-[800px]"
            />
          );
        })}
      </div>
    </div>
  </div>
</section>}

      {/* Division 5: How Does It Work */}
      <section className="py-12 md:py-16 lg:py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6">
          {/* Main heading with gradient background */}
          <h2
            className="text-8xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-8 sm:mb-12 md:mb-16 text-center"
            style={{
              // Use backgroundImage instead of background shorthand
              backgroundImage: appData?.division5?.featuresSection?.mainHeading?.style?.background,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              paddingBottom: "1rem",
              color: "transparent",
              // Explicitly set background color if you want to ensure nothing else interferes
              // Often needed with background-clip for full browser compatibility/reset
              backgroundColor: "transparent",
            }}
          >
            {appData?.division5?.featuresSection?.mainHeading?.text}
          </h2>

          {/* Container for feature content - only modifying height to be responsive */}
          <div className="relative max-w-5xl mx-auto h-[650px] sm:h-[600px] md:h-[520px] -mt-5 mb-10">
            {/* Map through features from config */}
            {features.map((feature, index) => (
              <div
                key={feature.id}
                className={`transition-all duration-1000 absolute inset-0 ${
                  activeFeatureSlide === index
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-10 pointer-events-none"
                }`}
              >
                <div className="flex flex-col md:flex-row items-center h-full">
                  {/* Image - First on mobile, second on desktop */}
                  <div className="w-full md:w-1/3 md:order-2 flex justify-center relative mb-6 md:mb-0">
                    <img
                      src={getMappedAssetUrl(feature.image)}
                      alt={feature.title || 'Feature illustration'}
                      className="rounded-lg max-h-[500px] md:max-h-none object-contain"
                    />
                  </div>

                  {/* Text - Second on mobile, first on desktop */}
                  <div className="w-full md:w-1/2 md:order-1 md:pr-10">
                    <h3
                      className="text-2xl sm:text-3xl font-bold mb-4"
                      style={{ color: appData?.division5?.featuresSection?.textColor || '#143E39' }}
                    >
                      {feature.title || ''}
                    </h3>
                    <p
                      className="text-base sm:text-lg md:text-xl"
                      style={{ color: appData?.division5?.featuresSection?.textColor || '#143E39' }}
                    >
                      {feature.description || ''}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Buttons container - now outside the features container */}
          <div className="relative max-w-5xl mx-auto">
            <button
              onClick={handleNextFeature}
              className="md:flex h-12 w-auto md:w-16 md:h-16 absolute right-0 top-0 -translate-y-[430px] md:-translate-y-[330px] items-center justify-center focus:outline-none transition-transform hover:scale-110"
              aria-label="Next feature"
            >
              <img src={getMappedAssetUrl('next_button.svg')} alt="Next" className="w-full h-full" />
            </button>
          </div>
        </div>
      </section>

      {/*  
      <section
        className="relative overflow-hidden"
        style={{
          background:
            "linear-gradient(113.52deg, #C0DFED -2.59%, #FFFFFF 102.06%)",
        }}
      >
        <div className="hidden lg:block absolute right-0 top-0 bottom-0 h-full">
          <img
            src={getMappedAssetUrl('double_helix.png')}
            alt="DNA Double Helix"
            className="h-full object-cover object-right"
          />
        </div>

        <div className="container mx-auto relative px-4 lg:px-0">
          <div className="w-full lg:w-auto lg:ml-[10%] lg:mr-[30%] my-8 lg:my-[88.5px] rounded-[30px] p-6 lg:p-[48px_40px_40px_40px] bg-white/30 backdrop-blur-[50px] shadow-[0px_4px_30px_0px_rgba(252,195,203,0.3)]">
            <div className="flex flex-col gap-5 lg:gap-10">
              <h2
                className="font-dm-sans font-bold text-3xl md:text-5xl lg:text-[72px] leading-tight lg:leading-[72px]"
                style={{
                  background:
                    "linear-gradient(89.85deg, #57A49D 0.12%, #A475C2 97.5%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                {appData?.division6?.mainHeading || ''}
              </h2>

              <div className="font-dm-sans text-base md:text-xl lg:text-2xl leading-[120%]">
                {division6Data.content.map((item, index) => {
                  if (item.type === "normal") {
                    return (
                      <span key={index} className="font-normal">
                        {item.text}
                      </span>
                    );
                  } else if (item.type === "italic") {
                    return (
                      <span key={index} className="font-normal italic">
                        {item.text}
                      </span>
                    );
                  } else if (item.type === "bold") {
                    return (
                      <span key={index} className="font-semibold">
                        {item.text}
                      </span>
                    );
                  }
                  return null;
                })}
              </div>
            </div>

            <button
              className="mt-6 lg:mt-[40px] md:w-[189px] md:h-[61px] bg-[#6DC5BD] text-white rounded-[500px] px-6 hover:shadow-lg transition-all self-start"
              onClick={scrollToEmailInput} // Add this onClick handler
            >
              {appData?.division6?.buttonText || 'Sign Up Now'}
            </button>
          </div>
        </div>
      </section>*/}

      {/* Division 7: What Is Your Real Concern - Responsive */}
      <section
        ref={concernSectionRef}
        className="relative overflow-hidden py-12 md:py-20"
        style={{
          background: "linear-gradient(180deg, #ACDBE5 0%, #BF9ED3 100%)",
          minHeight: "600px",
        }}
      >
        {/* Main heading with improved mobile visibility */}
        <div
          className="text-center w-full px-4 mb-12 md:mb-0 md:absolute md:translate-y-[65%]"
          style={{
            top: "100px",
            left: "0",
            right: "0",
          }}
        >
          <h2 className="font-dm-sans font-bold text-white text-3xl xs:text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl 2xl:text-[128px] leading-tight tracking-normal mx-auto max-w-full md:max-w-[90%] lg:max-w-[80%] xl:max-w-[1016px]">
            What is your <span className="italic">real</span> concern
          </h2>
        </div>

        {/* Cards container - for better layout control */}
        <div className="relative mx-auto w-full h-[450px] sm:h-[500px] md:h-[600px] lg:h-[650px] mt-16 md:mt-32">
          {/* Energy Card - Bottom Left */}
          <div
            className={`absolute ${cardsFloated ? "animate-float-up" : ""}`}
            style={{
              width: "min(300px, 45vw)",
              height: "min(265px, 40vw)",
              left: "calc(25% - 50px)",
              top: cardsFloated ? "55%" : "200%",
              transform: "rotate(-11.84deg)",
              borderRadius: "30px",
              transition: "top 2.5s ease-out",
              zIndex: 2,
            }}
          >
            <div className="relative w-full h-full group">
              <img
                src={getMappedAssetUrl('GoalCard_Energy-default.png')}
                alt="Energy"
                className="w-full h-full object-contain absolute top-0 left-0 opacity-100 group-hover:opacity-0"
              />
              <img
                src={getMappedAssetUrl('GoalCard_Energy-hovered.png')}
                alt="Energy Hovered"
                className="w-full h-full object-contain absolute top-0 left-0 opacity-0 group-hover:opacity-100"
              />
            </div>
          </div>

          {/* Appearance Card - Top Right - moved further right */}
          <div
            className={`absolute ${cardsFloated ? "animate-float-up" : ""}`}
            style={{
              width: "min(300px, 45vw)",
              height: "min(265px, 40vw)",
              right: "calc(10% - 50px)",
              top: cardsFloated ? "5%" : "200%",
              transform: "rotate(-15deg)",
              borderRadius: "30px",
              transition: "top 2.5s ease-out",
              zIndex: 3,
            }}
          >
            <div className="relative w-full h-full group">
              <img
                src={getMappedAssetUrl('GoalCard_Appearance-default.png')}
                alt="Appearance"
                className="w-full h-full object-contain absolute top-0 left-0 opacity-100 group-hover:opacity-0"
              />
              <img
                src={getMappedAssetUrl('GoalCard_Appearance-hovered.png')}
                alt="Appearance Hovered"
                className="w-full h-full object-contain absolute top-0 left-0 opacity-0 group-hover:opacity-100"
              />
            </div>
          </div>

          {/* Emotions Card - Bottom Right */}
          <div
            className={`absolute ${cardsFloated ? "animate-float-up" : ""}`}
            style={{
              width: "min(300px, 45vw)",
              height: "min(265px, 40vw)",
              right: "calc(5% - 30px)",
              top: cardsFloated ? "50%" : "200%",
              transform: "rotate(10.77deg)",
              borderRadius: "30px",
              transition: "top 2.5s ease-out",
              zIndex: 1,
            }}
          >
            <div className="relative w-full h-full group">
              <img
                src={getMappedAssetUrl('GoalCard_Emotions-default.png')}
                alt="Emotions"
                className="w-full h-full object-contain absolute top-0 left-0 opacity-100 group-hover:opacity-0"
              />
              <img
                src={getMappedAssetUrl('GoalCard_Emotions-hovered.png')}
                alt="Emotions Hovered"
                className="w-full h-full object-contain absolute top-0 left-0 opacity-0 group-hover:opacity-100"
              />
            </div>
          </div>

          {/* Diet Card - Top Left */}
          <div
            className={`absolute ${cardsFloated ? "animate-float-up" : ""}`}
            style={{
              width: "min(300px, 45vw)",
              height: "min(265px, 40vw)",
              left: "calc(5% - 30px)",
              top: cardsFloated ? "10%" : "200%",
              transform: "rotate(14.38deg)",
              borderRadius: "30px",
              transition: "top 2.5s ease-out",
              zIndex: 4,
            }}
          >
            <div className="relative w-full h-full group">
              <img
                src={getMappedAssetUrl('GoalCard_Diet-default.png')}
                alt="Diet"
                className="w-full h-full object-contain absolute top-0 left-0 opacity-100 group-hover:opacity-0"
              />
              <img
                src={getMappedAssetUrl('GoalCard_Diet-hovered.png')}
                alt="Diet Hovered"
                className="w-full h-full object-contain absolute top-0 left-0 opacity-0 group-hover:opacity-100"
              />
            </div>
          </div>
        </div>

        {/* For responsive adjustments */}
        <style jsx>{`
          @media (max-width: 400px) {
            .h-[450px] {
              height: 550px;
            }
          }

          /* Adjusted media queries to match the new heading structure */
          @media (max-width: 639px) {
            div[style*='top: "100px"'] {
              top: 60px !important;
            }
          }

          @media (min-width: 1200px) {
            div[style*='top: "100px"'] {
              top: 160px !important;
            }

            /* Optional: Adjust the card sizes but keep responsive positioning */
            div[style*="width: min(300px, 45vw)"] {
              width: min(389px, 30vw) !important;
              height: min(343px, 26vw) !important;
            }
          }
        `}</style>
      </section>

      {/* Division 8: Comment Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="w-auto mx-auto ml-[5%] md:ml-[10%] relative h-[300px] sm:h-[350px] md:h-[400px]">
            {(testimonialsArray).map((testimonial, index) => {
              const firstName = testimonial?.name?.split(" ")[0].toLowerCase()
              const avatarFilename = `avr_${firstName}.svg`;
              const actualAvatarUrl = getMappedAssetUrl(avatarFilename);

              return (
                <div
                  key={index}
                  className={`transition-all duration-500 absolute inset-0 ${
                    activeTestimonial === index
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-10 pointer-events-none"
                  }`}
                >
                  {/* Mobile layout (up to md) */}
                  <div className="md:hidden w-full">
                    {/* Quotation and avatar side by side at the top */}
                    <div className="flex flex-row items-start justify-between mb-4">
                      <img
                        src={getMappedAssetUrl("icn_quotation.svg")}
                        alt="Quotation"
                        className="w-12 h-12"
                      />
                      <img
                        src={actualAvatarUrl}
                        alt={`${testimonial.name} avatar`}
                        className="h-12 w-auto"
                      />
                    </div>

                    {/* Quote text below */}
                    <p
                      className="text-xl pl-4 font-bold"
                      style={{
                        background:
                          "linear-gradient(89.85deg, #57A49D 0.12%, #A475C2 97.5%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      {testimonial.quote}
                    </p>
                  </div>

                  {/* Desktop layout (md and up) - keep original */}
                  <div className="hidden md:flex flex-row w-full">
                    <div className="w-3/4 relative">
                      <img
                        src={getMappedAssetUrl("icn_quotation.svg")}
                        alt="Quotation"
                        className="w-12 h-12 mb-4"
                      />
                      <p
                        className="text-3xl lg:text-4xl pl-4 font-bold"
                        style={{
                          background:
                            "linear-gradient(89.85deg, #57A49D 0.12%, #A475C2 97.5%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          backgroundClip: "text",
                          paddingBottom: "0.5rem",
                        }}
                      >
                        {testimonial.quote}
                      </p>
                    </div>
                    <div className="flex justify-center w-1/3 items-start mt-12">
                      <img
                        src={actualAvatarUrl}
                        alt={`${testimonial.name} avatar`}
                        className="w-[100%] lg:w-[60%] h-auto"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Division 9: Join Us */}
      {/*<section
        className="relative py-8 md:py-16 overflow-hidden"
        style={{
          backgroundImage: `url(${getMappedAssetUrl('joinus-bg.png')})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 1,
        }}
      >
        <div
          className="relative mx-auto my-8 md:my-16 w-[95%] md:w-[90%] max-w-[1209px]"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0)",
            borderRadius: "20px",
            border: "1px solid",
            borderImageSource:
              "linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 49.5%, #FFFFFF 100%)",
            backdropFilter: "blur(50px)",
            boxShadow: "0px 4px 30px 0px rgba(129, 216, 208, 0.4)",
            padding: "30px 24px 24px",
          }}
        >
          <div className="flex flex-col gap-4 md:gap-8">
            <div className="flex flex-row items-center gap-4 md:gap-8">
              <div className="w-[100px] h-[100px] md:w-[143px] md:h-[143px] rounded-[20px] md:rounded-[30px] flex-shrink-0">
                <img
                  src={getMappedAssetUrl('joinus-genni.svg')}
                  alt="Genni mascot"
                  className="w-full h-full object-contain"
                />
              </div>

              <h2
                className="font-dm-sans font-bold text-2xl md:text-5xl lg:text-[72px] leading-tight md:leading-[72px] tracking-[-2%] text-left"
                style={{
                  background:
                    "linear-gradient(89.85deg, #57A49D 0.12%, #A475C2 97.5%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                 {appData?.division9?.heading}
              </h2>
            </div>

            <p
              className="font-dm-sans font-normal text-base md:text-lg lg:text-[24px] leading-[120%] tracking-[0%]"
              style={{ color: "#143E39" }}
            >
              {appData?.division9?.description}
            </p>

            <div className="flex justify-start md:justify-end mt-4 md:mt-6">
              <div
                className="relative w-[180px] h-[46px] md:w-[238px] md:h-[61px] group cursor-pointer"
                onClick={scrollToEmailInput}
              >
                <img
                  src={defaultButtonUrl}
                  alt="Join the Waitlist"
                  className="absolute inset-0 w-full h-full object-contain group-hover:opacity-0"
                />
                <img
                  src={hoverButtonUrl}
                  alt="Join the Waitlist"
                  className="absolute inset-0 w-[184] h-[50] md:w-[244px] md:h-[67px] object-contain opacity-0 group-hover:opacity-100"
                />
              </div>
            </div>
          </div>
        </div>
      </section>*/}
      <BlogsSection 
  id="blogs"
  blogs={blogs}  // ← Use your API data
  isLoading={loadingBlogs}  // You can also pass the loading state
  readButtonSvg={readButtonSvg}
  readButtonHoverSvg={readButtonHoverSvg}
  circleDecorationSvg={circleDecorationSvg}
  title=""
/>
      <Footer />

      {/* Add custom styles */}
      <style jsx>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default MainPage;
